export const CLIENT_API_ALLOW_TO_AUTO_IMPORT = [
    "septeo",
    "fiducial",
]